import React, { useState } from 'react';
import { IoIosArrowBack } from "react-icons/io";
import { FaProjectDiagram, FaBlogger, FaFacebook, FaInstagram } from "react-icons/fa";
import { LuFileSpreadsheet } from "react-icons/lu";
import { MdOutlineContactMail } from "react-icons/md";
import { FiYoutube } from "react-icons/fi";
import { IoCodeSlash } from "react-icons/io5";
import { Link, useLocation } from "react-router-dom";
import { SiYoutubeshorts } from "react-icons/si";
import { AiFillHome } from "react-icons/ai";
import { GoCode } from "react-icons/go";
import { FaBarsStaggered } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import './sidebaroptions.css';

const SidebarOptions = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const location = useLocation(); // Get current location

    const navItems = [
        { label: "Home", icon: <AiFillHome />, link: "/" },
        { label: "Simple Codes", icon: <IoCodeSlash />, link: "/source-code" },
        { label: "UI Elements", icon: <GoCode />, link: "/ui-elements" },
        { label: "Portfolio", icon: <FaProjectDiagram />, link: "/protfolio" },
        { label: "Cheatsheets", icon: <LuFileSpreadsheet />, link: "/cheatsheets" },
        { label: "Blog", icon: <FaBlogger />, link: "/blog" },
        { label: "Contact Us", icon: <MdOutlineContactMail />, link: "/contact-us" },
    ];

    const socialItems = [
        { label: "Facebook", icon: <FaFacebook />, link: "https://www.facebook.com/supercodingbits/" },
        { label: "Instagram", icon: <FaInstagram />, link: "https://www.instagram.com/thesupercodingbits/#" },
        { label: "Youtube", icon: <FiYoutube />, link: "https://www.youtube.com/@supercodingbits" },
    ];

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const ClosetoggleSidebar = () =>{
        setIsSidebarOpen(false);
    }

    return (
        <>
            <div className="menu-toggle" onClick={toggleSidebar}>
                <FaBarsStaggered className='baricon' />
            </div>
            <aside className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
                <div className="menu-toggle" onClick={ClosetoggleSidebar}>
                    <IoClose className='Closebaricon' />
                </div>
                <div className="sidebar-nav">
                    <ul className="nav-list primary-nav">
                        {navItems.map((item, index) => (
                            <li key={index} className="nav-item">
                                <Link
                                    to={item.link}
                                    className={`nav-link ${location.pathname === item.link ? "active" : ""}`}
                                    onClick={toggleSidebar} // Close sidebar on link click
                                >
                                    <span className="nav-icon">{item.icon}</span>
                                    <span className="nav-label">{item.label}</span>
                                </Link>
                            </li>
                        ))}
                        {/* <hr /> */}
                        {socialItems.map((item, index) => (
                            <li key={index} className="nav-item">
                                <a
                                    href={item.link}
                                    target='_blank'
                                    rel="noopener noreferrer"
                                    className="nav-link"
                                    onClick={toggleSidebar} // Close sidebar on link click
                                >
                                    <span className="nav-icon">{item.icon}</span>
                                    <span className="nav-label">{item.label}</span>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </aside>
        </>
    );
};

export default SidebarOptions;